import { Button, Spinner, Textarea } from '@crm/ui';
import { Clock3, Send } from 'lucide-react';
import { useState } from 'react';
import { useCreateTicket } from '@/modules/support/api';
import { toErrorMessage } from '../../auth/utils';

const MENSAGEM_PADRAO =
  'Estamos expandindo nossa infraestrutura e equipe de suporte para conseguirmos atender novos assinantes. Seu cadastro entrará em uma fila de espera. Entraremos em contato em breve disponibilizando seu acesso. Desculpe o transtorno.';

/**
 * Tela da fila de espera: usada tanto ao fechar o cadastro (com a fila
 * ligada) quanto sempre que uma conta em espera loga de novo. A caixa de
 * mensagem e local (nao gravada) - fechar e abrir a tela mostra ela de novo,
 * mesmo se uma mensagem ja tiver sido enviada antes.
 */
export function WaitlistScreen() {
  const [mensagem, setMensagem] = useState('');
  const [enviado, setEnviado] = useState(false);
  const criar = useCreateTicket();

  async function enviar() {
    const texto = mensagem.trim();
    if (!texto) return;

    await criar.mutateAsync({
      subject: 'Mensagem da fila de espera',
      body: texto,
      images: [],
    });
    setEnviado(true);
  }

  return (
    <div className="mx-auto max-w-md space-y-6 py-10 text-center">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-3xl bg-primary/10">
        <Clock3 className="h-10 w-10 text-primary" />
      </div>

      <div className="space-y-2">
        <h1 className="text-lg font-semibold">Você está na fila de espera</h1>
        <p className="text-sm text-muted-foreground">{MENSAGEM_PADRAO}</p>
      </div>

      <div className="space-y-2 text-left">
        <p className="text-center text-sm font-medium">Gostaria de nos enviar uma mensagem?</p>

        {enviado ? (
          <p className="rounded-lg border border-border bg-muted/40 px-4 py-3 text-center text-sm text-muted-foreground">
            Mensagem enviada! Nosso time vai dar uma olhada em breve.
          </p>
        ) : (
          <>
            {criar.error ? (
              <p className="text-center text-sm text-destructive">{toErrorMessage(criar.error)}</p>
            ) : null}
            <Textarea
              rows={4}
              autoGrow
              placeholder="Escreva aqui..."
              value={mensagem}
              onChange={(event) => setMensagem(event.target.value)}
            />
            <Button
              className="w-full"
              disabled={!mensagem.trim() || criar.isPending}
              onClick={enviar}
            >
              {criar.isPending ? <Spinner className="h-4 w-4" /> : <Send className="h-4 w-4" />}
              Enviar
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
